import { isEmpty, startCase } from 'lodash'

import {
  TPosAccount,
  TPosAccountRole,
  IPosAccountWithRoles,
  TEmployeeRolesQuery,
} from 'types/posAccounts'

export const filterPosAccountsByRole = (
  posAccounts: TPosAccount[],
  employeeRole: TPosAccountRole[],
  rolesQuery: TEmployeeRolesQuery
) => {
  const posAccountsWithRoles: IPosAccountWithRoles[] =
    posAccounts?.reduce((acc: IPosAccountWithRoles[], cur: TPosAccount) => {
      const id = cur?.id
      const accountRoles = employeeRole
        ?.filter(({ employeeId }) => employeeId === id)
        .map(({ role }) => startCase(role) ?? '')

      return [...acc, { ...cur, roles: accountRoles }]
    }, []) ?? []

  switch (rolesQuery) {
    // return all posAccounts with roles when rolesQuery = 'all-roles'
    case 'all-roles': {
      return posAccountsWithRoles
    }
    // return posAccounts with role manager when rolesQuery = 'manager'
    case 'manager': {
      return posAccountsWithRoles?.filter(({ roles }) => roles?.[0]?.toLowerCase() === 'manager')
    }
    // return posAccounts with roles diffrent than manager when rolesQuery = 'cashier'
    case 'cashier': {
      return posAccountsWithRoles?.filter(
        ({ roles }) => roles?.[0]?.toLowerCase() !== 'manager' && !isEmpty(roles)
      )
    }
    default: {
      return posAccountsWithRoles
    }
  }
}
